import { render } from "./ToolsSection.vue?vue&type=template&id=79f6bafe"
import script from "./ToolsSection.vue?vue&type=script&lang=js"
export * from "./ToolsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__